
export const currency = "Rs."
export const currencyInWords = "Rupees"
export default { currency, currencyInWords }
